<!--
    DEPRECATED
    Consider using SauSpinner instead.
-->

<template>
    <div>
        <div class="row">
            <!-- Fetching Data -->
            <div class="col">
                <div class="sau-bx bx-pad text-center">
                    <img src="/img/spinner.gif" />
                    <h6 class="sau-pm-reset">
                        <slot name="message"></slot>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
            };
        },
    }
</script>